export default "img/background.d81341c2c596c27c86ccf026cfb05d04.jpg";